import React, {Component} from "react"
import styles from "./sign-button.module.css"

interface Props {
    disabled?: boolean
    onClick: () => void
}

export class SignButton extends Component<Props, {}> {
    private onClick(event) {
        const {onClick} = this.props
        event.preventDefault()
        event.stopPropagation()
        onClick()
    }

    public render() {
        const {disabled} = this.props
        return (
            <button className={styles.button} onClick={this.onClick.bind(this)} disabled={disabled}>
                SIGN
            </button>
        )
    }
}
